import { useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import { PPDialog } from 'components/PPDialog'
import { FormattedMessage } from 'react-intl'
import styles from './ErrorFallback.pcss'
import { useNavigate, useRouteError } from 'react-router'

export function RouteErrorView() {
  const navigate = useNavigate()
  const [errorVisible, setErrorVisible] = useState(false)
  const error = useRouteError()
  const isChunkError = error instanceof Error && /loading.*chunk|chunkloaderror/i.test(error.message)

  useEffect(() => {
    if (isChunkError) {
      if (!sessionStorage.getItem('chunk-reload')) {
        sessionStorage.setItem('chunk-reload', 'true')
        window.location.reload()
      }
    }
  }, [isChunkError])

  const toggleError = () => {
    setErrorVisible(current => !current)
  }

  const onRefresh = () => {
    navigate('/logout')
  }

  if (isChunkError) {
    return <div>Reloading app...</div>
  }

  return (
    <PPDialog
      open
      dismissible={false}
      size="sm"
      title={<FormattedMessage id="errors.app-crash" />}
      footer={
        <div className={styles['footer-actions']}>
          <a onClick={toggleError}>
            {errorVisible ? 'hide error' : 'see error'}
          </a>
          <Button color="primary" variant="contained" onClick={onRefresh}>
            <FormattedMessage id="actions.refresh" />
          </Button>
        </div>
      }
    >
      <div className={`${styles.message} ${errorVisible ? styles.visible : ''}`}>
        {error instanceof Error && (
          <>
            <p>{`Original error: ${error.name}`}</p>
            {error.stack && <p>{`Stack trace: ${error.stack}`}</p>}
          </>
        )}
        {error instanceof Response && (
          <p>{`HTTP ${error.status}: ${error.statusText}`}</p>
        )}
      </div>
    </PPDialog>
  )
}
